import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const WarimashiRyokin = props => {
  return <Dropdown.Static kubunKey='warimashi_ryokin' {...props} />
}
